import { SortByOption, sortByOptions } from 'v2/core/entities/feedback/sortBy';
import { create } from 'zustand';

export type TaxonomyStore = {
  selectedEntity: string;
  setSelectedEntity: (node: string) => void;
  selectedReason: string;
  setSelectedReason: (node: string) => void;

  selectedValue: string;
  setSelectedValue: (node: string) => void;
  resetSelection: () => void;

  selectedSortByOption: SortByOption;
  setSelectedSortByOption: (option: SortByOption) => void;

  searchQuery: string;
  setSearchQuery: (query: string) => void;
};

const useTaxonomyStore = create<TaxonomyStore>((set) => ({
  selectedSortByOption: sortByOptions[0],
  setSelectedSortByOption: (option): void =>
    set(() => {
      return { selectedSortByOption: option };
    }),
  selectedEntity: '',
  setSelectedEntity: (node): void =>
    set(() => {
      return { selectedEntity: node, selectedReason: '' };
    }),
  selectedReason: '',
  setSelectedReason: (node): void =>
    set(() => {
      return { selectedReason: node };
    }),

  selectedValue: '',
  setSelectedValue: (node): void =>
    set(() => {
      return { selectedValue: node };
    }),

  resetSelection: (): void =>
    set(() => {
      return {
        selectedEntity: '',
        selectedReason: '',
        selectedValue: '',
      };
    }),

  searchQuery: '',
  setSearchQuery: (query): void =>
    set(() => {
      return { searchQuery: query };
    }),
}));

export default useTaxonomyStore;
